// Copyright 2020-2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import styled from "styled-components";

export const SmallText = styled.small`
  color: rgba(0, 0, 0, 0.5);
`;

export const StyledCard = styled.div`
  .ch-body {
    margin-bottom: 1rem;
  }

  .ch-header {
    font-size: 1.5rem;
  }

  .ch-title {
    font-size: 1.25rem;
    margin-top: 1rem;
  }

  .ch-description {
    margin: 1rem 0 1rem 0;
  }
`;
